export const getPaymentPlans = (state, plansList) => {
    return state.getIn(['payment', 'plans']).filter( (v, k) => plansList.indexOf(k) >= 0)
}

//Filter by plan
//Filter by monthly/yearly
//Filter by ID



// WEBPACK FOOTER //
// ./src/model/Payment/selector.js